import { useMutation } from "@tanstack/react-query";

import timeZoneApi from "./apis/time_zone";

const useUpdateTimeZone = () =>
  useMutation({
    mutationFn: timeZoneApi.updateTimeZone,
    onSuccess: () => window.location.reload(),
  });

export { useUpdateTimeZone };
